import { Point } from 'chart.js'

const getYValue = (value: number | Point | null): number | null => {
	if (value == null) return null
	if (typeof value === 'number') return value
	if (typeof value === 'object' && 'y' in value) return value.y ?? null
	return null
}

export default getYValue
